import { FC } from "react";

import { STEP_TO_ELEMENT_ID } from "@/features/LiveFormEditor/AnimatePreview/Arrow/ArrowContext";
import { LabeledFormDate, LabeledFormDateProps } from "@/forms-design-system/FormDate";
import { useTranslate } from "@/hooks/useTranslate";
type ThemedAuctionFormDateProps = Omit<LabeledFormDateProps, "id" | "title" | "data-test">;

export const ThemedAuctionFormDate: FC<ThemedAuctionFormDateProps> = ({ ...rest }) => {
  const { t } = useTranslate();

  return (
    <LabeledFormDate
      id={STEP_TO_ELEMENT_ID["date"]}
      title={t("ticketing", "dateSummary.auctionClosing")}
      data-test="ticketing-date-summary"
      {...rest}
    />
  );
};
